export enum LinkAction {
    DELETE = "Delete",
    EDIT = "Edit",
    ADD = "Add"
}

export function linkActionToColor(linkAction: LinkAction) {
    if (linkAction === LinkAction.DELETE) {
        return "red"
    } else if (linkAction === LinkAction.EDIT) {
        return "blue"
    } else if (linkAction === LinkAction.ADD) {
        return "green"
    } else {
        return "black"
    }
}